<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <TablePicker v-model="value.parameter1" title="Data Table" />
      </v-col>
      <v-col cols="12">
        <ServerFieldMultiSelect
          v-model="value.columns"
          :table="value.parameter1"
          title="Data Columns"
        />
      </v-col>
      <v-col cols="12">
        <ServerFilterEditor v-model="value.filters" :table="value.parameter1" />
      </v-col>
      <v-col cols="12">
        <DataOutputPicker
          title="Output"
          v-model="value.parameter2"
          :workflow="true"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TablePicker from "../../ui/shared/TablePicker.vue";
import ServerFieldMultiSelect from "../../ui/shared/ServerFieldMultiSelect.vue";
import DataOutputPicker from "../../ui/shared/DataOutputPicker.vue";
import ServerFilterEditor from "../../ui/shared/ServerFilterEditor.vue";

export default {
  name: "GetDataDesigner",

  components: {
    TablePicker,
    ServerFieldMultiSelect,
    DataOutputPicker,
    ServerFilterEditor,
  },

  props: ["value"],
};
</script>